<template>
    <div class="frb frb-info" v-if="isActive">
        <input ref="radio_method" type="radio" autocomplete="off" :id="'radio-button-unlimint'+unlimintType" name="radio-button" @click="select" :checked="methodSelected"
               value="unlimint" />
        <label :for="'radio-button-unlimint'+unlimintType">
            <div class="card-body">
                <div v-if="isBoleto" class="boleto_chekout"></div>
                <div v-if="isCreditCard" class="processingpartner_chekout">
                    <ul class="list-unstyled list-inline">
                        <li class="list-inline-item">
                          <img src="../../../../static/templates/img/loghi_pagamenti/mastercard_checkout.png" class="img-responsive inline-block checkoutcard" alt="mastercard" height="30" />
                        </li>
                        <li class="list-inline-item">
                          <img src="../../../../static/templates/img/loghi_pagamenti/visa_checkout.png" class="img-responsive inline-block checkoutcard" alt="visa" height="30" />
                        </li>
                      </ul>
                </div>
                <p class="small mb-1 mt-2" v-if="showInvoiceFormLink">
                    <a href="#" @click.stop.prevent="onShowInvoiceForm">
                        {{ $parent.wantReceiveInvoiceMessage }}
                    </a>
                </p>
            </div>
        </label>
    </div>
</template>

<script>
    // import Translations from "./insert-me-to-translate.vue";

    import paymentMethodMixin from "./mixins/payment-method-mixin";

    export default {
        name: "unlimint",
        props: {
            'unlimintType': {
                type: String,
                validator: function (value) {
                    // The value must match one of these strings
                    return ['BOLETO', 'CC', 'BITCOIN'].indexOf(value) !== -1;
                }
            },
        },
        mixins: [paymentMethodMixin],
        computed: {
            isBoleto: function () {
                return this.unlimintType === 'BOLETO';
            },
            isCreditCard: function () {
                return this.unlimintType === 'CC';
            }
        },
        methods: {
            async payResponseHandler(response) {
                  if (response.status === 200) {
                      if (response.data.success === "OK") {
                        if (response.data.data.redirect_url) {
                          window.location = response.data.data.redirect_url;
                        } else {
                          this.show_errors(null, response.data.error_message || gettext("System error. Please try again later"))
                        }
                      } else {
                          this.show_errors(null, response.data.error_message || gettext("System error. Please try again later"))
                      }
                  } else {
                      console.error(response);
                  }
            },
        },
    }
</script>
